export enum HeaderTabType {
    Home,
    DigitalNameplate
}
